import React from "react";
import { useState, useEffect } from "react";
import { useLocation} from "react-router-dom";
import { Card, Accordion, Col, Row, Form} from 'react-bootstrap';
import axios from "axios";
import "./landingpage.css"

function CategoryGroups() {
    const [active, setActive] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [categoryGroupsData, setCategoryGroupsData] = useState({ categoryGroups: [], grandTotal: 0 })
    const [displayCategoryGroups, setdisplayCategoryGroups] = useState({ categoryGroups: [], grandTotal: 0 })
    const [countryName, setCountryName] = useState('');

    const location = useLocation();
    

    useEffect(() => {
        const fetch = (async () => {
            try{
                const searchParams = new URLSearchParams(location.search);
                let country = searchParams.get("country")?.toLowerCase().trim();
                country= (country==='us'?'US':(country==='in'?'IN':''));
                setCountryName(country);

                if(!country){
                   country = await fetchIpCountry()
                   setCountryName(country);
                }

                const categoryGroupsResponse = await axios.get(`/getcategorygroups?country=${country}`);
                const categoryGroups =categoryGroupsResponse.data
                const totalLeads = categoryGroups.reduce((sum, row) => sum + parseInt(row.count), 0)
                setCategoryGroupsData({ categoryGroups: categoryGroups, grandTotal: totalLeads });
                setdisplayCategoryGroups({ categoryGroups: categoryGroups, grandTotal: totalLeads });
            }catch (error) {
                console.log("Error occurs: ", error);
            }
        });
        fetch();
         if (window.AOS) {
            window.AOS.init({
                duration: 800,
                easing: 'ease-in-out',
                mirror: false,
                offset: 120
            });
        }
    }, []);

    const formatNumber = ((num) => {
        const number = parseInt(num);
        return (isNaN(number) ? '' : number.toLocaleString());
    });

    const handleSearch= (query)=>{
       if(query.length<=3){
          setdisplayCategoryGroups(categoryGroupsData);
       }else{
  
           const filterData = categoryGroupsData.categoryGroups.map((group)=>{
                const categorygroup = group.categorygroup.toLowerCase().trim()
                const isGroupMatch = categorygroup.includes(query.toLowerCase().trim())
                
                if(isGroupMatch){
                    return group
                }else{
                    const matchSubcategories = group.subcategories?.filter((sc)=> {
                                const subcategory = sc.category?.toLowerCase().trim();
                                return subcategory?.includes(query.toLowerCase().trim())
                        })
                
                    if(matchSubcategories.length>0){
                            return {...group, subcategories:matchSubcategories};
                    }
                }
            }).filter(Boolean);   
         
            const totalLeads = filterData.reduce((sum, row) => sum + parseInt(row.count), 0)      
        
            setdisplayCategoryGroups({ categoryGroups: filterData, grandTotal: totalLeads })
            }       
  }

  const handleChange = (e) => {
        const value = e.target.value
        setSearchQuery(value)
        handleSearch(value);
    }

   const fetchIpCountry = async()=>{
        const publicIP = await axios.get('https://api.ipify.org?format=json',{timeout: 2000});
        const ipInforesponse = await axios.get(`/ipInfo/${publicIP.data.ip}`);
        let ipcountry = ipInforesponse.data.ipInfo.country.toLowerCase();
        ipcountry = (ipcountry==='india'?'IN':(ipcountry==='us'?'US':''))
        return ipcountry
   }

   const handleSelect = async(country)=>{
       setCountryName(country);
       const categoryGroupsResponse = await axios.get(`/getcategorygroups?country=${country}`);
       const categoryGroups =categoryGroupsResponse.data
       const totalLeads = categoryGroups.reduce((sum, row) => sum + parseInt(row.count), 0)
       setCategoryGroupsData({ categoryGroups: categoryGroups, grandTotal: totalLeads });
       setdisplayCategoryGroups({ categoryGroups: categoryGroups, grandTotal: totalLeads })
   }

    return (<>
        <div class="landing-page-main py-3">

            <section class="tam" data-aos="fade-up">
                    <div class="container header">
                        <div class="row text-center">
                            <h3>Determine your</h3>
                            <h2 class="tam-title">Total Addressable Market (TAM)</h2>
                            <h3>across 4,500+ Industries & Business Categories</h3>
                            {/* {planid === 3 || planid === 1 ? '' :
                                <div class="my-3 text-center">
                                    {!planid || planid === 7 ?
                                        <a href="/signup" class="btn-get-started text-center">FREE SIGNUP<br /><small>No Credit Card</small></a>
                                        : <a href="/pricing" class="btn-get-started text-center">UPGRADE<br /><small>To Premium Plan</small></a>
                                    }
                                </div>
                            } */}
                        </div>
                    </div>
            </section>

            <Row className="col-md-10 col-lg-10 col-xl-10 col-12 px-md-4 px-lg-4 px-xl-4 px-2 mx-auto text-center justify-content-center fs-6 categorygroup" data-aos="fade-up">

                <Card className="mb-3 border-0 col-md-10 my-3">

                    <Card.Header className="bg-primary text-white fw-bold py-3 position-relative header">
                        <Row>
                            <Col md={5} className="text-start searchbar">
                                <input type="text" placeholder="Search...." value={searchQuery} onChange={handleChange}/>
                                <span onClick={()=>handleSearch(searchQuery)}><i class="bi bi-search"></i></span>
                            </Col>
                            <Col md={5} className="text-md-start text-center"><span className="">Business Category Groups</span></Col>
                            <Col md={2} className="text-end">
                                <div>
                                    <Form.Select value={countryName} onChange={(e) => handleSelect(e.target.value)} className="country-selector">
                                        <option value="US">US</option>
                                        <option value="IN">IN</option>
                                        <option value="">All</option>
                                    </Form.Select>
                                </div>
                            </Col>
                        </Row>
                    </Card.Header>

                    <Card.Body style={{ padding: 0 }}>
                        <Row className="bg-light mx-1 fw-bold shadow" style={{ padding: '10px 15px' }}>
                            <Col md={4} xs={4} className="text-start">Category Group</Col>
                            <Col md={4} xs={4}>Category</Col>
                            <Col md={4} xs={4} className="text-end">Count</Col>
                        </Row>

                        <Accordion activeKey={active}>
                            {displayCategoryGroups?.categoryGroups?.map((g,idx)=>(
                                <Accordion.Item eventKey={String(idx)} key={idx}>

                                    <Accordion.Header onClick={() => setActive(active === String(idx) ? null : String(idx))}>
                                        <Row className="position:sticky" style={{ width: '100%', fontSize: "clamp(0.8rem, 1vw, 1.6rem)"}}>
                                            <Col md={9} xs={7} className="fw-semibold px-4 text-muted"><a href={`/catalogsummary?categorygroup=${g.categorygroup??''}&country=${countryName}`}>{g.categorygroup ?? ''}</a></Col>
                                            <Col md={3} xs={5} className="fw-bold text-end text-muted">{formatNumber(g.count)}</Col>
                                        </Row>
                                    </Accordion.Header>

                                    <Accordion.Body className="p-0 p-md-3 p-lg-3">
                                        {g.subcategories && g.subcategories.length ? (
                                            <div className="overflow-y-auto overflow-x-hidden" style={{ maxHeight: "300px" ,fontSize: "clamp(0.8rem, 1vw, 1.6rem)" }}>
                                                {g.subcategories.map((c, i) => (
                                                    parseInt(c.leads_count) >10 ? (
                                                        <Row key={i} style={{ padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                        <Col md={5} xs={5}></Col>
                                                        <Col md={4} xs={4} className="text-start fw-semibold"><a href={`/catalogsummary?category=${c.category??''}&country=${countryName}`}>{c.category ?? ''}</a></Col>
                                                        <Col md={3} xs={3} className="fw-semibold" style={{ textAlign: 'right', paddingRight: '25px' }}>{formatNumber(c.leads_count)}</Col>
                                                    </Row>
                                                    ):''))
                                                }
                                            </div>
                                           ) : (<div style={{ color: '#666' }}>No categories available for this group.</div>)
                                        }
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                        <div className="d-flex justify-content-between bg-light  border-4 border-primary border-top fw-bold">
                            <p className="px-4 py-1">Grand Total</p>
                            <p className="pe-4 py-1">{formatNumber(displayCategoryGroups.grandTotal)}</p>
                        </div>
                    </Card.Body>
                </Card>
            </Row>
        </div>
    </>)
}

export default CategoryGroups;